import React, { useState, useEffect } from "react";

import './../PopUp.css';
import './ShowFile.css';

import { RegisterModalData, RegisterModalObserver, SetModalState } from "../../../interface/PopUp";

import { Svg_Close } from "../../Svg";

interface ShowFileData {
    type? : string;
    file? : string;
}

export default function PopUp_ShowFile() {

    const [ modalData, setModaldata ] = useState<ShowFileData>({});
    const [ showPopUp, setShowPopUp ] = useState(false);
    
    function ClosePopUp(){
        SetModalState('ShowFile', false);
    }
    
    useEffect(()=>{
        RegisterModalData('ShowFile', setModaldata);
        RegisterModalObserver('ShowFile', setShowPopUp);
    }, []);      

    return(
        (showPopUp ?
            <div className="PopUp PopUpCenter">
                <div className="all ShowFile">
                    <div className="div_title">
                        <div className="">Show file</div>
                        <div className="close" onClick={ ClosePopUp }>
                            <Svg_Close className="icons" color="#B1B2B2" />
                        </div>
                    </div>
                    <div className="div_data">
                        {
                            modalData.file ?
                                <img alt="img" src={ modalData.file } className="show_img" />
                            : <div className="div_no_data">No data to show</div>
                        }
                    </div>
                </div>
                <div className="close_all" onClick={ ClosePopUp } />
            </div>
        : <React.Fragment></React.Fragment>)
    )
}
